import React from 'react';
import { HEALTH_STATUS } from '@/const';
import { HealthStatusIndicator } from '@/components/shared/display/StateIndicator';

export const LegendContent = () => {
  return (
    <div>
      <div className="flex flex-col items-start gap-4">
        <HealthStatusIndicator type={HEALTH_STATUS.CRITICAL} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.ALARM} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.MONITOR} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.HEALTHY} showDescription />
        <HealthStatusIndicator type={HEALTH_STATUS.NOT_AVAILABLE} showDescription />
      </div>
    </div>
  );
};